export default __webpack_public_path__ + "images/699a6423e206848c0d5a459c2feee1f5-small-talk.svg";